import { ACTIVELY_PUBLISHING } from '../constants/messageTypes';
export function buildActivelyPublishingObject(props = {}) {
  return Object.assign({
    '@type': ACTIVELY_PUBLISHING,
    threadId: null,
    channel: null,
    message: null,
    timestamp: null
  }, props);
}